/**
 * GET /allocation-questionnaire/strategy — full strategy questionnaire payload.
 *
 * Belongs here: path, axios, and React Query hook.
 * Does not belong here: answer session or review UI.
 */
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '../../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../../env'
import type { StrategyQuestionnairePayload } from '../shared/types/questionnaire.types'
import { STRATEGY_QUESTIONNAIRE_QUERY_KEY } from './queryKeys'

export const STRATEGY_QUESTIONNAIRE_PATH = `${mobileBackendUrl}/v2/portfolio/allocation-questionnaire/strategy`

/** GET strategy questionnaire definition + saved answers. */
export async function fetchStrategyQuestionnaire(): Promise<StrategyQuestionnairePayload> {
  const response = await axiosInstance.get<StrategyQuestionnairePayload>(STRATEGY_QUESTIONNAIRE_PATH)
  if (!response?.data) {
    throw new Error('Failed to fetch strategy questionnaire')
  }
  return response.data as StrategyQuestionnairePayload
}

/** Strategy questionnaire query — retry 1. */
export function useStrategyQuestionnaireQuery() {
  return useQuery({
    queryKey: STRATEGY_QUESTIONNAIRE_QUERY_KEY,
    queryFn: fetchStrategyQuestionnaire,
    retry: 1
  })
}
